"use strict";
import { Theme } from "./src/Theme.dev.js";
import coreStyles from "./src/theme.css.js";
Theme.registerThemeFragment("spectrum", "system", coreStyles);
//# sourceMappingURL=core.dev.js.map
